<style lang="scss" scoped>
  .page-right-part {
    box-sizing: content-box;
    width: 800px;
    padding: 30px 0;
    overflow: auto;

    .title {
      margin-left: 30px;
    }

    .order-info-part {
      padding: 0 50px;
    }

    .goods-info-left {
      width: 330px;
      margin-left: 30px;
      padding: 20px;
      float: left;
      border: 1px solid rgb(238, 238, 238);
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    .goods-info-right {
      width: 210px;
      padding: 32px 20px 33px 20px;
      background-color: rgb(238, 238, 238);
      border: 1px solid rgb(238, 238, 238);
      float: left;

      .el-row {
        margin-bottom: 5px;
      }

      margin-bottom: 20px;
    }

    .min-gutter {
      .el-form-item {
        margin-bottom: 4px;
      }
    }

    .border-show {
      height: 15px;
      width: 100%;
      border-bottom: 1px solid #777777;
      opacity: 0.2;
      margin-bottom: 10px;
    }

  }


  .exceptionPosition {
    /*margin-left: 40px;*/
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .table {
    .order-list-item {
      color: #999;
      line-height: 20px;
    }

    border-collapse: separate;
    border-spacing: 0;

    > tbody > tr > td {
      border-top: 1px solid #eee;
    }

  }

  .R {
    word-wrap: break-word;
    word-break: break-all;
  }

  .empty-position {
    width: 150px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .w90 {
    width: 90px;
  }

  .page-right-part {
    width: 750px;
    padding: 0 0 30px 0;
  }

  .base-pic-item {
    border: 1px solid #eee;
    position: relative;
    cursor: pointer;
    width: 180px;
    margin: 5px;
    padding: 10px;
    font-size: 12px;

    img {
      width: 180px;
      height: 180px;
      display: block;
      background: #ccc;

    }

  }

  .margin-left {
    margin-left: 15px;
  }

  .margin-left-right {
    margin-left: 38px;
    margin-right: 38px;
  }

  .power-style-part {
    margin: 12px 0;
    background-color: rgb(238, 238, 238);
    padding: 12px 10px 10px 10px;
  }

  .el-form .el-checkbox__label {
    font-size: 12px;
    padding-left: 5px;
  }

  .el-form .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }

  .margin-bottom {
    margin-bottom: 2px !important;
  }

  .border-show {
    height: 20px;
    border-bottom: 1px solid #777777;
    opacity: 0.2;
    margin-left: 40px;
    margin-right: 40px;
    margin-bottom: 20px;
  }

  .right-title {
    background-color: #b1b1b1;
    height: 30px;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 20px;
    padding-top: 10px;

  }

  .content-part {
    position: absolute;
    top: 40px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;

    .content-left {
      width: 120px;
      height: 100%;
      float: left;
      background-color: rgb(238, 238, 238);

      .list-style {
        cursor: pointer;
        padding: 8px 5px 8px 5px;

        &:hover {
          background-color: #ffffff;
        }
      }

      .click-it {
        background-color: #ffffff;
      }
    }

    .content-right {
      width: 510px;
      height: 100%;
      float: left;
      padding-top: 10px;

      .hide-content {
        display: none;
      }

      .show-content {
        display: block;
      }
    }

    .min-gutter {
      .el-form-item {
        margin-bottom: 4px;
      }

      .el-form-item__label {
        font-size: 12px
      }
    }
  }

  .locked {
    border-left: 5px solid #fa0;
    text-indent: -5px;
  }

  .d-table-col-wrap {
    overflow: auto;
  }

  .list-item {
    padding-right: 10px;
  }
  .opera-btn-group .advanced-query-form > .el-row {
    display: block;
    .oms-form-row {
      margin-bottom: 10px;
    }
  }
</style>
<template>
  <div class="order-page">
    <div class="container">

      <div class="opera-btn-group" :class="{up:!showSearch}">
        <div class="opera-icon">
          <span class="pull-right opera-btn" style="margin-left: 10px">
            <perm label="mdm-goods-add">
              <span @click.stop="addType">
                   <a href="#" class="btn-circle" @click.prevent="" style="margin-right: 5px"><i
                     class="el-icon-t-plus"></i> </a>添加
              </span>
            </perm>
          </span>
          <span class="pull-left switching-icon" @click="showSearch = !showSearch">
              <i class="el-icon-arrow-up"></i>
              <span v-show="showSearch">收起筛选</span>
              <span v-show="!showSearch">展开筛选</span>
            </span>
        </div>
        <el-form v-show="showSearch" class="advanced-query-form" onsubmit="return false">
          <el-row>
            <el-col :span="8">
              <oms-form-row label="货品分类" :span="5">
                <el-select placeholder="请选择货品分类" v-model="searchCondition.typeId" clearable>
                  <el-option :label="item.label" :value="item.key" :key="item.key" v-for="item in typeId">
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="生产厂商" :span="6">
                <el-select filterable remote placeholder="请输入名称/拼音首字母缩写/系统代码搜索生产厂商" :remote-method="filterOrg"
                           :clearable="true" v-model="searchCondition.factoryId" popperClass="good-selects">
                  <el-option :value="org.id" :key="org.id" :label="org.name" v-for="org in orgList">
                    <div style="overflow: hidden">
                      <span class="pull-left" style="clear: right">{{org.name}}</span>
                    </div>
                    <div style="overflow: hidden">
                          <span class="select-other-info pull-left">
                            <span>系统代码:</span>{{org.manufacturerCode}}
                          </span>
                    </div>
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="货品名称" :span="6">
                <oms-input type="text" v-model="searchCondition.keyWord" placeholder="请输入货品名称"></oms-input>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="货品编号" :span="5">
                <oms-input type="text" v-model="searchCondition.code" placeholder="请输入货品编号"></oms-input>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="货品ID" :span="5">
                <oms-input type="text" v-model.trim="searchCondition.id" placeholder="请输入货品ID"></oms-input>
              </oms-form-row>
            </el-col>
            <el-col :span="16">
              <oms-form-row label="" :span="1">
                <el-button type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
                <el-button native-type="reset" @click="resetSearchForm">重置</el-button>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="order-list-status container" style="margin-bottom:20px">
        <div class="status-item" style="width: 90px" :class="{'active':key==activeStatus,'item-right':item.type===0} "
             v-for="(item,key) in orgType"
             @click="changeType(key,item)">
          <div class="status-bg" :class="['b_color_'+key]"></div>
          <div><i class="el-icon-caret-right" v-if="key==activeStatus"></i>{{item.title}}<span
            class="status-num">{{item.num}}</span></div>
        </div>
      </div>

      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="2">货品分类</el-col>
          <el-col :span="2">货品编号</el-col>
          <el-col :span="5">货品名称</el-col>
          <el-col :span="4">规格</el-col>
          <el-col :span="5">生产企业</el-col>
          <el-col :span="4">药品批准文号</el-col>
          <el-col :span="2">操作</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="showTypeList.length == 0">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div v-else="" class="order-list-body flex-list-dom">
          <div class="order-list-item" v-for="item in showTypeList" @click="showInfo(item)"
               :class="['status-'+filterListColor(item),{'active':activeId==item.id}]">
            <el-row>
              <el-col :span="2">
                <div class="R">
                  {{formatGoodsTypeList(item.typeId)}}
                </div>
              </el-col>
              <el-col :span="2">
                <div class="vertical-center R">
                  {{item.code}}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="R">
                  {{item.name}}
                </div>
              </el-col>
              <el-col :span="4">
                <div class="R">
                  {{ item.specifications}}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="R">
                  {{ item.factoryName }}
                </div>
              </el-col>
              <el-col :span="4">
                <div class="vertical-center R ">
                  {{ item.approvalNumber }}
                </div>
              </el-col>
              <el-col :span="2" class="opera-btn">
                <div>
                  <perm label="mdm-goods-edit" class="btn-line-block"
                        v-if="(item.auditedStatus==='0'&& item.state==='0')||item.state==='1'">
                    <span @click.stop="showInfo(item)">
                      <a @click.pervent="" class="btn-circle btn-opera">
                        <i class="el-icon-t-search"></i>
                      </a>
                     查看
                    </span>
                  </perm>
                  <perm label="mdm-goods-edit" class="btn-line-block" v-if="item.state==='0'">
                    <span @click.stop="edit(item)">
                      <a @click.pervent="" class="btn-circle btn-opera">
                        <i class="el-icon-t-edit"></i>
                      </a>
                     编辑
                    </span>
                  </perm>
                </div>
              </el-col>
            </el-row>
            <div class="order-list-item-bg"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-show="showTypeList.length && !loadingData">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="pager.currentPage"
                     :page-sizes="[20,50,100]" :page-size="20" layout="total, sizes, prev, pager, next, jumper"
                     :total="pager.count">
      </el-pagination>
    </div>
    <page-right :show="showRight" @right-close="closeTitle" :css="{'width':'750px'}">
      <edit-form :formItem="form" :title="formTitle" :action="action" :actionType="showRight"
                 @right-close="resetRightBox"
                 @change="itemChange" :getDefaultForm="getDefaultForm"></edit-form>
    </page-right>
    <page-right :show="showTypeRight" @right-close="resetRightBox" :css="{'width':'750px'}">
      <show-form :formItem="goodsInfo" :title="formTitle" :actionType="showTypeRight" @change="itemChange"
                 @right-close="resetRightBox" :getDefaultForm="getDefaultForm"></show-form>
    </page-right>
    <page-right :show="showMergeRight" @right-close="resetRightBox" :css="{'width':'750px'}">
      <merge-form :formItem="mergeGoods" @change="itemChange" @right-close="resetRightBox"></merge-form>
    </page-right>
    <page-right :show="showtext" @right-close="resetRightBox" :css="{'width':'750px'}">
      <leadForm :showtext="showtext" @change="itemChange" @right-close="resetRightBox"></leadForm>
    </page-right>
  </div>
</template>
<script>
  import utils from '@/tools/utils';
  import {BaseInfo, Goods} from '../../../resources';
  import editForm from './form/form.vue';
  import showForm from './form/show.vue';
  import goodsRow from './goods.row.vue';
  import attachmentLists from '../../common/attachmentList.vue';
  import orderMixin from '@/mixins/orderMixin';
  import mergeForm from './form/merge.vue';
  import leadForm from './form/lead-form';

  export default {
    components: {
      editForm, goodsRow, attachmentLists, showForm, mergeForm, leadForm
    },
    mixins: [orderMixin],
    data: function () {
      return {
        showtext: false,
        activeId: '',
        orgList: [],
        searchCondition: {
          factoryId: '',
          keyWord: '',
          typeId: '',
          code: '',
          id: ''
        },
        goodsInfo: {},
        loadingData: true,
        attachmentIdList: [],
        showRight: false,
        showTypeRight: false,
        showTypeSearch: false,
        showSearch: true,
        filters: {
          auditedStatus: '1',
          state: 0,
          typeId: '',
          factoryId: '',
          keyWord: ''
        },
        typeList: [],
        showTypeList: [],
        typeTxt: '',
        keyTxt: '',
        form: this.getDefaultForm(),
        orgType: {
//          0: {'title': '所有', 'num': '0', 'status': null, 'auditedStatus': null},
          0: {'title': '正常', 'num': '', 'status': 0, 'auditedStatus': '1'},
          1: {'title': '待审核', 'num': '', 'status': 0, 'auditedStatus': '0'},
          2: {'title': '审核未通过', 'num': '', 'status': 0, 'auditedStatus': '2'},
        },
        // 货品分类
        kindsMenu: [
          {title: '全部', key: ''},
          {title: '药品', key: '0'},
          {title: '疫苗', key: '1'},
          {title: '器械', key: '2'},
          {title: '化妆品', key: '3'}
        ],
        kindsTitle: '全部',
        activeStatus: 0,
        action: '',
        formTitle: '新增',
        currentItem: {
          state: '',
          id: ''
        },
        baseQueryGoods: [],
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 20,
          totalPage: 1
        },
        isInit: false,
        showMergeRight: false,
        mergeGoods: {}
      };
    },
    filters: {
      formExpiryUnit: function (value) {
        let array = {
          0: '年',
          1: '月',
          2: '日'
        };
        return array[value];
      }
    },
    mounted() {
      this.getPageList(1);
      // 点开详情时, 如果刷新页面, 保留刷新前状态
      let productId = this.$route.params.productId;
      if (productId) {
        this.activeId = productId;
        // this.goodsInfo = JSON.parse(JSON.stringify(item));
        this.showTypeRight = true;
        this.queryGoodsDetail(productId);
      }
    },
    watch: {
      'typeTxt': {// 列表搜索过滤
        handler: function () {
          this.getPageList(1);
        },
        deep: true
      },
      // filters: {// 监控货品分类（所有/正常...）
      //   handler() {
      //     this.getPageList(1);
      //   },
      //   deep: true
      // }
    },
    computed: {
      bodyHeight: function () {
        return this.$store.state.bodyHeight;
      },
      typeId() {
        return this.$store.state.goodsTypeList;
      }
    },
    beforeRouteLeave (to, from, next) {
      if(!this.showRight) {
        next(true);
        return;
      }
      this.$confirm('信息未保存，是否关闭', '', {
        confirmButtonText: ' 是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        next(true);
      }).catch(() => {
        next(false);
      })
    },
    methods: {
      closeTitle() {
        this.$confirm('信息未保存，是否关闭', '', {
          confirmButtonText: ' 是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.resetRightBox();
        })
      },
      getDefaultForm() {
        return {
          id: null,
          code: null,
          factoryGoodsCode: null,
          name: null,
          expiryUnit: 1,
          businessScope: null,
          dosageForm: null,
          specifications: null,
          origin: null,
          factoryId: null,
          factoryName: null,
          importation: null,
          typeId: '',
          measurementUnit: null,
          unitPrice: null,
          qualityStandard: null,
          registrationNumber: null,
          registrationNOValidity: null,
          importGoodsApprovalDate: null,
          approvalNumber: null,
          goodsApprovalNOValidity: null,
          goodsApprovalNumberApprovalDate: null,
          expiryNumber: null,
          genericName: null,
          certificationMark: null,
          storageType: null,
          storageConditionId: null,
          largePacking: null,
          mediumPacking: null,
          smallPacking: null,
          storageStartTemperature: null,
          storageEndTemperature: null,
          transportStartTemperature: null,
          transportEndTemperature: null,
          eanCode: null,
          packageSize: null,
          shipmentPackingUnit: null,
          largePackageUnit: null,
          mediumPackageUnit: null,
          smallPackageUnit: null,
          minpackageLength: null,
          minpackageWidth: null,
          minpackageHeight: null,
          minpackageVolume: null,
          minPackageWeight: null,
          smallpackageLength: null,
          smallpackageWidth: null,
          smallpackageHeight: null,
          smallpackageVolume: null,
          smallPackageWeight: null,
          mediumpackageLength: null,
          mediumpackageWidth: null,
          mediumpackageHeight: null,
          mediumpackageVolume: null,
          mediumPackageWeight: null,
          largepackageLength: null,
          largepackageWidth: null,
          largepackageHeight: null,
          largepackageVolume: null,
          largePackageWeight: null,
          circulationBoxCount: null,
          wholePackageScheme: null,
          namePhonetic: null,
          nameAcronymy: null,
          photo: null,
          packageFlag: false,
          goodsTrackNo: null,
          goodsTrackFlag: false,
          propertyMap: {
            nationImmuneProjectVaccineFlag: false,
            goodsUsedDosage: null,
            goodsUsedDosageUnit: null,
            personPortion: null,
            nationBasicDrugsSign: null,
            goodsOtc: null,
            specialDrugsFlag: null,
            anabolicAgentsSign: null,
            athletesCaution: null,
            peptideHormoneFlag: null,
            specialDrugCompoundPreparation: null,
            registrationRecordNumber: null,
            goodsRecordNOValidity: null,
            antiShockFlag: null,
            antiTiltFlag: null,
            marketingApprovalPossessorType: null
          }
        };
      },
      formatGoodsTypeList(val) {
        let goodsTypeList = this.$store.state.goodsTypeList;
        return goodsTypeList[val - 1] && goodsTypeList[val - 1].label || val;
      },
      exportGoodsInfo: function () {
        let params = Object.assign({}, this.filters, this.searchCondition);
        this.$store.commit('initPrint', {
          isPrinting: true,
          moduleId: '/platform/goods'
        });
        this.$http.get('/dhs-goods/export-info', {params}).then(res => {
          utils.download(res.data.path, '货品信息表');
          this.$store.commit('initPrint', {
            isPrinting: false,
            moduleId: '/platform/goods'
          });
        }).catch(error => {
          this.$store.commit('initPrint', {
            isPrinting: false,
            moduleId: '/platform/goods'
          });
          this.$notify.error({
            message: error.response.data && error.response.data.msg || '导出失败'
          });
        });
      },
      importGoodsInfo: function () {
        this.showtext = true;
      },
      mergeGoodsInfo: function (item) {
        this.showMergeRight = true;
        this.mergeGoods = JSON.parse(JSON.stringify(item));
        this.currentItem = JSON.parse(JSON.stringify(item));
        this.activeId = item.id;
      },
      exportFile: function () {
        let params = Object.assign({}, this.filters, this.searchCondition);
        this.$store.commit('initPrint', {
          isPrinting: true,
          moduleId: '/product'
        });
        this.$http.get('/dhs-goods/export/package', {params}).then(res => {
          utils.download(res.data.path, '货品包装表');
          this.$store.commit('initPrint', {
            isPrinting: false,
            moduleId: '/product'
          });
        }).catch(error => {
          this.$store.commit('initPrint', {
            isPrinting: false,
            moduleId: '/product'
          });
          this.$notify.error({
            message: error.response.data && error.response.data.msg || '导出失败'
          });
        });
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.getPageList(1);
      },
      handleCurrentChange(val) {
        this.getPageList(val);
      },
      filterOrg: function (query) {
        let param = {
          keyWord: query,
          orgRelationTypeList: ['1', '2', '3', '4', '5', '6', '7']
        };
        BaseInfo.queryByOrgRelationTypeList(param).then(res => {
          this.orgList = res.data.list;
        });
      },
      searchInOrder: function () {// 搜索
        Object.assign(this.filters, this.searchCondition);
        this.getPageList(1);
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          factoryId: '',
          keyWord: '',
          typeId: '',
          code: '',
          id: ''
        };
        this.orgList = [];
        Object.assign(this.searchCondition, temp);
        Object.assign(this.filters, temp);
        this.getPageList(1);
      },
      changeFinds: function (val) {
        this.filters.typeId = val;
        this.kindsMenu.forEach(item => {
          if (val === item.key) {
            this.kindsTitle = item.title;
          }
        });
      },
      getPageList: function (pageNo) {
        this.pager.currentPage = pageNo;
        let param = Object.assign({}, {
          pageNo: pageNo,
          pageSize: this.pager.pageSize,
          deleteFlag: false,
          keyWord: this.typeTxt
        }, this.filters);
        this.loadingData = true;

        this.$http({
          url: '/dhs-goods/operating-goods',
          method: 'post',
          params: {
            pageNo: param.pageNo,
            pageSize: param.pageSize,
            keyWord: param.keyWord
          },
          data: param
        }).then(res => {
          this.showTypeList = res.data.list;
          this.typeList = res.data.list;
          if (res.data.list.length > 0) {
            this.currentItem = res.data.list[0].id;
          } else {
            this.currentItem = Object.assign({'id': ''});
          }
          this.pager.count = res.data.count;
          this.loadingData = false;
        });
        this.queryStatusNum(param);
      },
      queryStatusNum: function (params) {
        this.$http({
          url: '/dhs-goods/operating-goods/count',
          method: 'post',
          params: {
            pageNo: params.pageNo,
            pageSize: params.pageSize,
            keyWord: params.keyWord
          },
          data: params
        }).then(res => {
          let data = res.data;
          this.orgType[0].num = data['normal'];
          this.orgType[1].num = data['audit'];
          this.orgType[2].num = data['notAudit'];
        });
      },
      queryGoodsDetail: function (id) {
        Goods.getGoodsDetail(id).then(res => {
          this.currentItem = Object.assign({state: ''}, res.data);
          this.goodsInfo = JSON.parse(JSON.stringify(res.data));
          this.form = JSON.parse(JSON.stringify(res.data));
          // 判断该货品资料是否被锁定
          // this.isLocked(res.data);
        }).catch((error) => {
          this.currentItem = {};
          this.$notify.info({
            duration: 2000,
            title: '无法查看',
            message: error.response.data.msg
          });
        });
      },
      filterListColor: function (item) {// 过滤左边列表边角颜色
        let index = 0;
        if (item.state === '0' && item.auditedStatus === '1') {
          index = 0;
        } else if (item.state === '0' && item.auditedStatus === '0') {
          index = 1;
        } else if (item.state === '0' && item.auditedStatus === '2') {
          index = 2;
        } else if (item.state === '1') {
          index = 3;
        }
        return index;
      },
      resetRightBox: function () {
        this.showRight = false;
        this.showTypeRight = false;
        this.showMergeRight = false;
        this.showtext = false;
        this.currentItem = {};
        this.goodsInfo = {};
        this.activeId = '';
        this.action = '';
      },
      addType: function () {
        this.action = 'add';
        this.showRight = true;
        this.form = this.getDefaultForm();
      },
      searchType: function () {
        this.showTypeSearch = !this.showTypeSearch;
        this.showSearch = !this.showSearch;
        this.filterOrg();
      },
      edit: function (item) {
        this.queryGoodsDetail(item.id);
        this.activeId = item.id;
        this.action = 'edit';
        this.index = 0;
        this.showRight = true;
      },
      showInfo: function (item) {
        this.activeId = item.id;
        // this.goodsInfo = JSON.parse(JSON.stringify(item));
        this.showTypeRight = true;
        this.queryGoodsDetail(item.id);
      },
      remove: function () {
        this.$confirm('确认删除货品' + this.currentItem.name + '"?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          Goods.delete(this.currentItem.id).then(() => {
            this.getPageList(1);
            this.$notify.success({
              title: '成功',
              message: '已成功删除"' + this.currentItem.name + '"'
            });
          });
        });
      },
      removeType: function (item) {
        Goods.delete(item.id).then(() => {
          this.getPageList(1);
          this.$notify.success({
            title: '成功',
            message: '已成功删除' + item.name
          });
        });
      },
      showType: function (type) {
        this.queryGoodsDetail(type.id);
      },
      changeType: function (key, item) {// 根据当前选中的标签，重置状态等相关参数。
        this.activeStatus = key;
        this.filters.auditedStatus = item.auditedStatus;
        this.filters.state = item.status;
        this.getPageList(1);
      },
      itemChange: function (item) {//  处理表单发出的change事件
//        if (this.action === 'add') {
        this.getPageList(this.pager.currentPage);
//        } else {
//          this.currentItem = item;
//          let idList = [];
//          this.showTypeList.forEach(val => {
//            idList.push(val.id);
//          });
//          this.showTypeList.splice(idList.indexOf(this.currentItem.id), 1, item);
//          this.attachmentIdList = item.attachmentIdList;
//        }

      }
    }
  };
</script>
